import { useIsMobile } from '@cp/ds/src/hooks/useIsMobile';
import { useTheme } from '@cp/ds/src/hooks/useTheme';
import { Box, BoxProps } from '@cp/ds/src/components/box';
import { Container } from '@cp/ds/src/components/container';
import { Grid } from '@cp/ds/src/components/grid';
import { Typography } from '@cp/ds/src/components/typography';
import { WithUpperline } from '@cp/ds/src/components/withUpperline';
import React from 'react';
import { toAssetItem } from '@cp/shared/image';
import BackgroundEllipsesSvg from '../../../../assets/shapes/feedbackFormBackground.svg?url';
import SvgConcaveSectionMask from '../../../../assets/shapes/concaveSectionMask.svg?url';

export interface SupportSendMessageProps extends BoxProps {
  leftBlockTitle?: React.ReactNode;
  leftBlockContent?: React.ReactNode;
  rightBlock?: React.ReactNode;
}
export const SupportSendMessage = React.forwardRef<HTMLDivElement, SupportSendMessageProps>(
  ({ leftBlockTitle, leftBlockContent, rightBlock, ...props }, ref) => {
    const isMobile = useIsMobile();
    const theme = useTheme();

    return (
      <Box
        ref={ref}
        sx={{ py: { xs: 5, md: 14 }, background: theme.palette.gray[100], position: 'relative', overflow: 'hidden' }}
        {...props}
      >
        <Box
          style={{
            display: 'flex',
            position: 'absolute',
            top: -2,
            color: theme.palette.white,
            background: `url(${toAssetItem(SvgConcaveSectionMask).src}) center center no-repeat`,
            width: '100%',
            transform: 'rotate(180deg)',
            zIndex: 1,
          }}
        >
          <svg fill="none" preserveAspectRatio="none" viewBox="0 0 800 38">
            <path d="M800 0C600 50 200 50 0 0v38h800V0z" fill="currentColor"></path>
          </svg>
        </Box>
        <Container>
          <Grid container direction="row" justifyContent="space-between">
            <Grid item md={5} sx={{ zIndex: 1 }} xs={12}>
              <WithUpperline>
                <Typography component="h4" sx={{ typography: { xs: 'h5', md: 'h4' }, m: 0, mb: 2.75 }}>
                  {leftBlockTitle}
                </Typography>
              </WithUpperline>
              {leftBlockContent}
            </Grid>
            <Grid item lg={5} md={6} sx={{ zIndex: 1, mt: { xs: 0, md: 2 } }} xs={12}>
              {rightBlock}
            </Grid>
          </Grid>
        </Container>
        {!isMobile && (
          <Box
            style={{
              background: `url(${toAssetItem(BackgroundEllipsesSvg).src}) center center no-repeat`,
              position: 'absolute',
              top: -310,
              left: 115,
              backgroundSize: 'contain',
              width: '130%',
              height: '100%',
            }}
          />
        )}
      </Box>
    );
  },
);
